var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"outlined":"","clearable":!_vm.readonly,"disabled":_vm.disabled,"items":_vm.data,"value":_vm.value,"label":_vm.model.title,"error-messages":_vm.error,"item-text":"text","item-value":"value"},on:{"input":function($event){return _vm.onInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }